import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Company Approval Request Services
 * !== 업체 승인 요청 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/coaprv`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/co-usr`,
    nodes: [],
};

export const URLS = {
    ptli0915001q: `${BASE.path}/ptli0915001q`, // Request for company approval List !==  업체 승인 요청 목록 ==!
    ptli0915002s: `${BASE.path}/ptli0915002s`, // Request for company approval Details !==  업체 승인 요청 상세 ==!
};

export const APIS = {
    // Check Company Approval List !==  업체 승인 요청 목록 조회 ==!
    getCoAprvRqstList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Company Approval details inquiry !== 업체 승인 요청 상세 정보 조회 ==!
    getCoAprvRqstInfo: (xtrnUsrAplyId: any) => {
        return api.get(`${BASE.api}/${xtrnUsrAplyId}`);
    },
    // Check Company Type applications List !==  업체 유형 신청 목록 조회 ==!
    getCoTpAplyList: (xtrnUsrAplyId: any) => {
        return api.get(`${BASE.api}/coTpList?xtrnUsrAplyId=${xtrnUsrAplyId}`);
    },
    // Execute Company User Approval !== 업체 사용자 승인 ==!
    executeCoAprv: (data: any) => {
        return api.post(`${BASE.api}/aprv`, {
            ...data,
        });
    },
    // Execute Company User Approval !== 업체 사용자 반려 ==!
    executeCoRtrn: (data: any) => {
        return api.post(`${BASE.api}/rtrn`, {
            ...data,
        });
    },

    updateCoTpInfo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },

    // Save payment ID in user application information !== 사용자 신청 정보에 결재 ID를 저장한다 ==!
    saveUsrAplyId: (data: any) => {
        return api.post(`${BASE.api}/usr-aprv-id`, {
            ...data,
        });
    },
};

export const SF_CO_APRV_SRCH: TFormSchema = {
    id: "form_coAprvSrch",
    schema: {
        coTin: { type: "text", label: "L_CO_TIN" },
        coNm: { type: "text", label: "L_CO_NM" },
        usrNm: { type: "text", label: "L_USR_NM" },
        bsopPrcssStat: {
            type: "select",
            label: "L_BSOP_PRCSS_STAT",
            options: [
                { label: "Unprocessed", value: "U" },
                { label: "Requested", value: "A01" },
                { label: "In Progress", value: "A02" },
                { label: "Completed", value: "A03" },
                { label: "Rejected", value: "B02" },
                { label: "Returned", value: "B04" },
            ],
            all: true,
        },
        coTpCd: {
            label: "L_CO_TP_CD",
            type: "select",
            area: "comnCd",
            comnCd: "COM0011",
            all: true,
            editType: "both",
        },
    },
};

export const SG_CO_APRV_LIST: TGridSchema = {
    id: "grid_coAprvList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN_TP", binding: "tinTp", width: "10%" }] },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: "10%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_RPPN_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_STTS", binding: "tinStat", width: "10%" }] },
        { cells: [{ header: "L_BSOP_PRCSS_STAT", binding: "bsopPrcssStat", width: "15%" }] },
        { cells: [{ header: "L_DELY_YN", binding: "delyYn", width: "5%" }] },
        { cells: [{ header: "L_SBTM_DTM2", binding: "frstRgsrDtm", width: "10%" }] },
    ],
    body: [
        {
            cells: [{ binding: "tinTp" }],
        },
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coNm", align: "left" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "tinStat" }],
        },
        {
            cells: [{ binding: "bsopPrcssStat" }],
        },
        {
            cells: [{ binding: "delyYn" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
    ],
};

export const SF_USR_APLY_INFO: TFormSchema = {
    id: "form_usrAplyInfo",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_RPPN_TIN" },
        usrNm: { type: "text", label: "L_RPPN_NM" },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            defaultValue: "N",
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md" },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO" },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", controlSize: 10 },
        usrPwd: { type: "password", label: "L_USR_PWD" },
        usrPwdCfrm: { type: "password", label: "L_USR_PWD_CFRM" },
        aprvYn: { type: "text", label: "L_APRV_YN" },
        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN", controlSize: 10, rows: 5 },
        preXtrnUsrAplyId: { type: "text", label: "L_PRE_XTRN_USR_APLY_ID" },

        coAplyId: { type: "text", label: "L_CO_APLY_ID" },
        coTin: { type: "text", label: "L_CO_TIN" },
        coNm: { type: "text", label: "L_CO_NM" },
        inwdCoYn: {
            type: "radio",
            label: "L_INWD_CO_YN",
            options: [
                { label: "Domestic Company", value: "Y" },
                { label: "Foreign Company", value: "N" },
            ],
            defaultValue: "Y",
        },
        rprsTelno: { type: "text", label: "L_RPRS_TELNO" },
        rprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO" },
        rprsEml: {
            type: "text",
            label: "L_RPRS_EML",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
        },
        coAddr: { type: "text", label: "L_CO_ADDR", controlSize: 10 },
        aprvPrcssStatCdNm: { type: "text", label: "L_PRCSS_STTS", edit: false },
        aprvPrcssOpinCn: { type: "text", label: "L_APRV_PRCS_OPIN_CN", edit: false },
    },
};

export const SF_CO_TP_INFO: TFormSchema = {
    id: "form_coTpInfo",
    schema: {
        coTin: { label: "L_CO_TIN", type: "text" },
        coSn: { label: "L_CO_SN", type: "text" },
        coTpCd: {
            label: "L_CO_TP_CD",
            type: "select",
            all: false,
            area: "comnCd",
            comnCd: "COM0011",
        },
        coCdRo: { label: "L_CO_CD", type: "text", placeholder: "automatically generated", readOnly: true },
        coCd: { label: "L_CO_CD", type: "text", placeholder: "Direct input" },
        tasacCrtfNoStr: { label: "L_TASC_CRTF_NO", type: "text" },
        coTpNm: { label: "L_CO_CD_NM", type: "text" },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                dclrYn: "Y",
            },
        },
        prcssStatCd: { label: "L_PRCSS_STAT_CD", type: "text" }, //본 테이블에만 존재
        statMdfyRsn: { label: "L_STAT_MDFY_RSN", type: "text" }, //본 테이블에만 존재
        gainCfrmOmsnYn: {
            type: "select",
            label: "L_GAIN_CFRM_OMSN_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        gaotCfrmOmsnYn: {
            type: "select",
            label: "L_GAOT_CFRM_OMSN_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        stckCretCtraTpCd: {
            type: "select",
            label: "L_STCK_CRET_CTRA_TP_CD",

            area: "comnCd",
            comnCd: "CGM0095",
        },
        stckClarCtraTpCd: {
            type: "select",
            label: "L_STCK_CLAR_CTRA_TP_CD",
            area: "comnCd",
            comnCd: "CGM0096",
        },
        autoCriYn: {
            type: "select",
            label: "L_AUTO_CRI_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        autoCroYn: {
            type: "select",
            label: "L_AUTO_CRO_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        wrhsDpstDays: { label: "L_WRHS_DPST_DAYS", type: "number" },
        psnWrhsYn: {
            type: "select",
            label: "L_PSN_WRHS_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        spcdlWrhsYn: {
            type: "select",
            label: "L_SPCDL_WRHS_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        rskCagYn: {
            type: "select",
            label: "L_RSK_CAG_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        bsopId: {
            type: "file",
            label: "L_ATCH_FILE",
            edit: true,
            bsopClsfCd: "PTL",
            isPublic: true,
        },
        lcneUseTpCd: {
            type: "select",
            label: "L_LCNE_TP_CD",
            area: "comnCd",
            comnCd: "LCM0019",
        },
    },
};

export const SG_CO_TP_APLY_LIST: TGridSchema = {
    id: "grid_coAprvList",
    options: { pagination: "in", index: true, height: "auto" },
    head: [
        { cells: [{ header: "L_CO_CD", binding: "coCd", width: 300 }] },
        { cells: [{ header: "L_CO_TP_CD", binding: "coTpCd", width: 150 }] },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: 300 }] },
        { cells: [{ header: "L_CO_CD_NM", binding: "coTpNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: 500 }] },
    ],
    body: [
        {
            cells: [{ binding: "coCd" }],
        },
        {
            cells: [{ binding: "coTpCd" }],
        },
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coTpNm" }],
        },
        {
            cells: [{ binding: "cstmOfceCd", type: "code", area: "cstmCd" }],
        },
    ],
};

// 첨부파일
export const ATCH_FILE_VISIBILITY_MAP = new Map([
    ["AL", new Set(["bsopId"])],
    ["WA", new Set(["bsopId"])],
    ["FF", new Set(["bsopId"])], // Freight Fowarder
    ["SA", new Set(["bsopId"])], // Shipping Agent
    ["SL", new Set(["bsopId"])], // Shipping line
    ["TA", new Set(["bsopId"])], // Terminal Operators
    ["TO", new Set(["bsopId"])], // Terminal Operators (Sea)
]);

// 필드 가시성 메타 정보
export const FIELD_VISIBILITY_MAP = new Map([
    [
        "WA",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
            "spcdlWrhsYn",
        ]),
    ],
    [
        "WB",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WC",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WD",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WE",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WF",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WG",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WH",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WI",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
            "rskCagYn",
        ]),
    ],
    [
        "WK",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WL",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WM",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WP",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WR",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WT",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WV",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WW",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WX",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WZ",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    // 추가 coTpCd 및 필드 정의
]);

export const CO_CD_INPUT_TRGT_SET = new Set(["AL", "BK", "FF", "SA", "SL", "VD"]);

export const CO_CD_INPUT_TASAC_SET = new Set(["FF", "SA", "SL"]);

interface InputProperties {
    maxLength: number;
    placeholder: string;
}

export const CO_CD_INPUT_PROPERTIES: { [key: string]: InputProperties } = {
    AL: { maxLength: 2, placeholder: "Enter the 2-char code" },
    BK: { maxLength: 8, placeholder: "Enter the 8-char(4char + 2char + 2char) code" },
    FF: { maxLength: 4, placeholder: "Enter the 4-char code" },
    SA: { maxLength: 3, placeholder: "Enter the 3-char code" },
    SL: { maxLength: 3, placeholder: "Enter the 3-char code" },
    VD: { maxLength: 9, placeholder: "Enter the code" },
};

// Request for approval of the company group by company type !== 업체유형별 업체승인 그룹결재요청 ==!
export const JNIA_APRV_RQST_CO_TP_CD_SET = new Set(["AL", "TA", "WA"]);
export const DSM_APRV_RQST_CO_TP_CD_SET = new Set(["FF", "SA", "SL", "TO"]);
export const CSC_APRV_RQST_CO_TP_CD_SET = new Set(["WU"]);
export const TMU_APRV_RQST_CO_TP_CD_SET = new Set(["VD"]);
export const LCNE_APRV_RQST_CO_TP_CD_SET = new Set([
    "C",
    "IC",
    "WB",
    "WC",
    "WD",
    "WE",
    "WF",
    "WG",
    "WH",
    "WI",
    "WK",
    "WL",
    "WM",
    "WP",
    "WR",
    "WW",
]);
export const BASIC_APRV_RQST_CO_TP_CD_SET = new Set(["B", "IM", "RA", "RW", "TP", "TR", "TY", "WT", "WX", "WY", "FI"]);
